/**
 * 全局配置：env/mock
 * 地址管理：接口base地址、MockApi地址
 * 获取系统环境，默认dev，开发环境
 */

const projectInfo = import.meta.globEager('../../package.json')
const versions = Object.entries(projectInfo)[0][1].version
// console.log(JSON.stringify(import.meta.env))
const env = import.meta.env.VITE_USER_NODE_ENV //? 'dev' : 'prod'
console.log('web端当前环境:' + env)

const EnvConfig = {
  // 前端人员开发环境
  dev: {
    baseApi: '', // http://112.74.210.163:16830
    imgUrl: 'http://112.74.210.163:16806/login_qrcode_image/',
    graphicalCodeUrl: 'http://112.74.210.163:16806/login_checkcode_image/',
    upload: 'http://112.74.210.163:16810/',
    loginUrl: 'http://112.74.210.163:9080',
    gomain: '112.74.210.163',
    goLoginSMUrl: 'http://112.74.210.163:9081',
    goLoginMMUrl: 'http://112.74.210.163:9082',
    downloadUrl: 'http://112.74.210.163:16820',
    versions,
    wsUrl: '',
    singOutUrl: '/',
    backSysUrl: 'http://112.74.210.163:9980/truemerger-admin/admin/login' // 后台管理系统
  },
  test: {
    // 测试环境
    baseApi: 'http://112.74.210.163:16830',
    imgUrl: 'http://112.74.210.163:16806/login_qrcode_image/',
    graphicalCodeUrl: 'http://112.74.210.163:16806/login_checkcode_image/',
    upload: 'http://112.74.210.163:16810/',
    loginUrl: 'http://112.74.210.163:9080',
    gomain: '112.74.210.163',
    goLoginSMUrl: 'http://112.74.210.163:9081',
    goLoginMMUrl: 'http://112.74.210.163:9082',
    downloadUrl: 'http://112.74.210.163:16820',
    versions,
    wsUrl: '',
    singOutUrl: '/',
    backSysUrl: 'http://112.74.210.163:9980/truemerger-admin/admin/login' // 后台管理系统
  },
  // 生产环境
  prod: {
    baseApi: 'https://xxoo.truemerger.com',
    imgUrl: 'https://yzm.truemerger.com/login_qrcode_image/',
    graphicalCodeUrl: 'https://yzm.truemerger.com/login_checkcode_image/',
    upload: 'https://upload.truemerger.com/',
    loginUrl: 'https://www.truemerger.com',
    gomain: 'truemerger.com',
    goLoginSMUrl: 'https://sao.truemerger.com',
    goLoginMMUrl: 'https://login.truemerger.com',
    downloadUrl: 'http://download.truemerger.com',
    versions,
    wsUrl: '',
    singOutUrl: '/',
    backSysUrl: 'http://admin.truemerger.com/truemerger-admin/admin/login' // 后台管理系统
  }
}
export default {
  env, // 当前环境dev|test|prod
  routePass: false, // 全局设置所有路由免验证，仅在开发环境下生效
  mock: false, // 是否开启全局mock,即使开启，在生产环境也不会生效
  namespace: '__WANRUILONG', // 项目localStorage\sessionStorage命名空间
  ...EnvConfig[env]
}
